const WS_URL = "https://ws.braytron.space/";
const WS_SEND_MESSAGE = "prompt";

export { WS_URL, WS_SEND_MESSAGE };
